import React from 'react';
import { Button } from './Button';
import { ShieldCheck, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-navy-900 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-83">
      <div className="mx-auto max-w-7xl" data-id="element-84">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center" data-id="element-85">
          <div className="flex flex-col justify-center text-center lg:text-left" data-id="element-86">
            <div className="mb-6 inline-flex items-center justify-center lg:justify-start gap-2 text-gold-400 font-semibold tracking-wider text-sm uppercase" data-id="element-87">
              <span className="flex text-gold-400" data-id="element-88">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" data-id="element-89" />)}
              </span>
              <span data-id="element-90">El Sistema #1 Para Hispanos</span>
            </div>

            <h1 className="mb-6 text-5xl sm:text-6xl lg:text-7xl font-bebas leading-[1.1] text-white" data-id="element-91">
              El Método 72h Para Limpiar Tu Crédito y Llegar a{' '}
              <span className="text-gold-400" data-id="element-92">700+ Puntos</span> — Sin Pagar a
              Nadie
            </h1>

            <p className="mb-8 text-lg sm:text-xl text-slate-300 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-93">
              Las mismas leyes que protegen a los bancos también te protegen a
              ti. Aprende a usarlas hoy.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center" data-id="element-94">
              <Button data-id="element-95">¡QUIERO MIS 700 PUNTOS AHORA!</Button>
            </div>

            <div className="mt-6 flex items-center justify-center lg:justify-start gap-2 text-sm text-slate-400" data-id="element-96">
              <ShieldCheck className="h-5 w-5 text-green-500" data-id="element-97" />
              <span data-id="element-98">Pago 100% Seguro • Descarga Inmediata</span>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-99">
            {/* Glow effect */}
            <div className="absolute left-1/2 top-1/2 -z-10 h-[300px] w-[300px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-500/20 blur-[100px]" data-id="element-100"></div>
            <img src="https://cdn.magicpatterns.com/uploads/meMnx1rVy2wfikc36UUxhS/IMAGE-GUIA_DE_CREDITO_7002B_EL_METODO_72H.png" alt="Guía de Crédito 700+ en un iPhone" className="relative z-10 mx-auto w-full max-w-sm drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-101" />
          </div>
        </div>
      </div>
    </section>;
}